document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-vh-product]').forEach(function (root) {
    var main = root.querySelector('[data-vh-main-image]');
    root.querySelectorAll('[data-vh-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!main) return;
        main.src = thumb.dataset.image;
        main.alt = thumb.dataset.alt || '';
        root.querySelectorAll('[data-vh-thumb]').forEach(function (item) { item.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    var quantity = root.querySelector('[data-vh-qty]');
    var minus = root.querySelector('[data-vh-qty-minus]');
    var plus = root.querySelector('[data-vh-qty-plus]');
    if (quantity && minus) minus.addEventListener('click', function () { quantity.value = Math.max(1, Number(quantity.value || 1) - 1); });
    if (quantity && plus) plus.addEventListener('click', function () { quantity.value = Number(quantity.value || 1) + 1; });

    var variantData = root.querySelector('[data-vh-variants]');
    var productForm = root.querySelector('.vh-product-form');
    var variantInput = root.querySelector('[data-vh-variant-input]');
    var buyNowButton = root.querySelector('[data-vh-buy-now]');
    var stickyJumpButton = root.querySelector('[data-vh-sticky-jump]');
    var colorPicker = root.querySelector('[data-vh-color-picker]');
    var selectionLabel = root.querySelector('[data-vh-selection]');
    var stickySelection = root.querySelector('[data-vh-sticky-selection]');
    var colorLabel = root.querySelector('[data-vh-color-label]');
    var stockLabels = root.querySelectorAll('[data-vh-stock]');
    if (variantData && variantInput) {
      var parsed = JSON.parse(variantData.textContent);
      var selectedOptions = parsed.selected.slice();

      function syncVariant() {
        var match = parsed.variants.find(function (item) {
          return item.options.every(function (value, index) { return value === selectedOptions[index]; });
        });
        if (!match) return;
        variantInput.value = match.id;
        if (selectionLabel) selectionLabel.textContent = selectedOptions.join(' / ');
        if (stickySelection) stickySelection.textContent = selectedOptions.join(' / ');
        if (colorLabel) colorLabel.textContent = selectedOptions[0] || '';
        stockLabels.forEach(function (label) {
          var stock = Number(match.inventory_quantity);
          label.textContent = stock > 0 && stock <= 15 ? 'ONLY ' + stock + ' LEFT IN THIS VARIANT' : 'LIMITED DROP — WHILE STOCK LASTS';
        });
        if (buyNowButton) {
          buyNowButton.disabled = !match.available;
          buyNowButton.textContent = match.available ? buyNowButton.dataset.label : 'SOLD OUT';
        }
      }

      root.querySelectorAll('[data-vh-option]').forEach(function (control) {
        control.addEventListener('click', function () {
          var position = Number(control.dataset.position);
          selectedOptions[position] = control.dataset.value;
          root.querySelectorAll('[data-vh-option][data-position="' + position + '"]').forEach(function (item) {
            var active = item === control;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          syncVariant();
        });
      });

      root.querySelectorAll('[data-vh-option-select]').forEach(function (select) {
        select.addEventListener('change', function () {
          selectedOptions[Number(select.dataset.position)] = select.value;
          syncVariant();
        });
      });
    }

    if (stickyJumpButton) {
      stickyJumpButton.addEventListener('click', function () {
        (colorPicker || root).scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }

    if (buyNowButton && productForm) {
      buyNowButton.addEventListener('click', function () {
        var rootPath = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        buyNowButton.disabled = true;
        buyNowButton.textContent = 'OPENING CHECKOUT…';
        window.fetch(rootPath + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(productForm)
        }).then(function (response) {
          if (!response.ok) throw new Error('Unable to add selected variant');
          window.location.assign(rootPath + 'checkout');
        }).catch(function () {
          buyNowButton.disabled = false;
          buyNowButton.textContent = 'TRY AGAIN';
        });
      });
    }

    var marketCountry = root.querySelector('[data-vh-market-country]');
    if (marketCountry) {
      var markets = ['UNITED STATES', 'FRANCE', 'GERMANY', 'SPAIN', 'MOROCCO'];
      var marketIndex = 0;
      window.setInterval(function () {
        marketIndex = (marketIndex + 1) % markets.length;
        marketCountry.textContent = markets[marketIndex];
      }, 5200);
    }
  });
});
